var exports = {
  "M": "x936d19a0--d690e0--image_wrp",
  "d": "x936d19a0--d690e0--star",
};

module.exports = exports;
